export default "__VITE_ASSET__oYlJvUu1__"